export default __webpack_public_path__ + "static/media/prof_pic.78b5686e.jpg";